import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../core/models/RouteParams';
import WorkHourRecords from './WorkHourRecords';

interface OwnProps {}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(WorkHourRecords);
